const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitRsvp = async (payload) => {
  const res = await fetch(`${API}/rsvp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`RSVP failed: ${res.status}`);
  return res.json();
};

export const fetchWishes = async () => {
  const res = await fetch(`${API}/wishes`);
  if (!res.ok) throw new Error(`Wishes failed: ${res.status}`);
  return res.json();
};
